<template>
    <tr>
        <td class="placeholder-main">
            <div class="d-flex align-items-center">
                <div class="file-icon mr-2">
                    <div class="icon-container loading"></div>
                </div>
                <div class="d-flex flex-column">
                    <div class="file-text file-text-1 loading"></div>
                    <div class="file-text file-text-2 loading"></div>
                </div>
            </div>
        </td>
        <td class="align-middle">
            <div class="file-text file-text-3 loading"></div>
        </td>
    </tr>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
@import '../../styles/_loading';

.placeholder-main {
    width: 100%;
}
.placeholder-sub {
    width: 1%;
    white-space: nowrap;
}
.file-icon {
    font-size: 2.5em;
}
.file-icon .icon-container {
    height: 1em;
    width: 1em;
    position:relative;
    border-radius: 50%;
}

.file-text {
    margin: 2px 0;
    &.file-text-1 {
        height: 20px;
        width: 300px;
    }
    &.file-text-2 {
        height: 15px;
        width: 200px;
    }
    &.file-text-3 {
        height: 24px;
        width: 180px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-entry-placeholder.vue